import {createAsyncThunk} from '@reduxjs/toolkit'
import {AxiosResponse} from 'axios'
import instance from '@/config/axios'

export const getSubscriptions = createAsyncThunk('invoice/getInvoices',
  async (params: any) => {
    const paramText = new URLSearchParams(params)
    const url = `v1/subscriptions?${paramText}`
    const response: AxiosResponse<GeneralArrayResponse<Subscription>> = await instance.get(url)
    return response.data
  })

export const createSubscription = createAsyncThunk('subscription/createSubscription',
  async (data: SubscriptionPayload, {dispatch}) => {
    const response: AxiosResponse<BookingState> = await instance.post('v1/subscriptions', data)
    dispatch(getSubscriptions({}))
    return response.data
  })
